document.querySelectorAll<HTMLElement>('.block-hero-hover-cards').forEach((block) => {
	const stage = block.querySelector<HTMLElement>('.block-hero-hover-cards__stage');
	const defaultState = stage?.querySelector<HTMLElement>('.block-hero-default');
	const cardStates = stage?.querySelectorAll<HTMLElement>('.block-hover-card');
	const cards = block.querySelectorAll<HTMLElement>('.block-hero-hover-cards__card');

	if (!cardStates || !cards.length) {
		return;
	}

	const desktop = window.matchMedia('(min-width: 992px)');

	const reset = () => {
		defaultState?.classList.add('is-active');
		cardStates.forEach((s) => s.classList.remove('is-active'));
		cards.forEach((c) => c.classList.remove('is-active'));
	};

	cards.forEach((card, index) => {
		const activate = () => {
			if (!desktop.matches) {
				return;
			}
			defaultState?.classList.remove('is-active');
			cardStates.forEach((s, i) => s.classList.toggle('is-active', i === index));
			cards.forEach((c, i) => c.classList.toggle('is-active', i === index));
		};

		card.addEventListener('mouseenter', activate);
		card.addEventListener('focus', activate);
	});

	block
		.querySelector('.block-hero-hover-cards__card-strip')
		?.addEventListener('mouseleave', () => {
			if (desktop.matches) {
				reset();
			}
		});

	block.addEventListener('focusout', (event) => {
		const next = event.relatedTarget as Node | null;
		if (desktop.matches && (!next || !block.contains(next))) {
			reset();
		}
	});

	desktop.addEventListener('change', (event) => {
		if (!event.matches) {
			reset();
		}
	});
});
